import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@/core/localization';
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, getLinkTo, title, groups } = appSections.stocks;
export const stocksRoute = {
    path: rootPath,
    element: _jsx(ProtectedRoute, { groups: groups }),
    handle: {
        crumb: ({ params: { locationId } }) => _jsx(NavLink, { to: getLinkTo(locationId), children: title }),
    },
    children: [
        {
            index: true,
            // TODO: allow access only to 'Warehouse manager' (uncomment)
            // element: <ProtectedRoute allow={'Warehouse'} />,
            lazy: async () => {
                const { StockList } = await import('@/warehouse/modules/stocks');
                return { Component: StockList };
            },
        },
        {
            path: ':stockId',
            lazy: async () => {
                const { StockContainer } = await import('@/warehouse/modules/stocks');
                return { Component: StockContainer };
            },
            handle: {
                crumb: ({ params: { locationId, stockId } }) => (_jsx(NavLink, { to: `${getLinkTo(locationId)}/${stockId}`, children: t('stock.label') })),
            },
        },
    ],
};
